<template>
  <div>
    <!-- <drag :isPublic="true" :selectList="[]" @dropEnd="dropEnd" /> -->
    <div v-show="images.length!==0">
      <div class="function">
        <span>共{{images.length}}张</span>
      </div>
      <div class="img_box">

        <div class="single_img_box" v-for="(img,index) in images" :key="index">
          <div class="img">
            <el-image :src="img.smallSrc" :preview-src-list="getImgList(index)" fit="cover"></el-image>
          </div>
          <!-- <div class="del" @click="delImg(img,index)">{{img.isNew?'移除':''}}</div> -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// import drag from './drag.vue'
export default {
  components: {
    // drag
  },
  data () {
    return {
      images: [],
      hasOldImg: false
    }
  },
  methods: {
    getImgList (index) {
      let list = this.images.reduce((list, item) => {
        list.push(item.src)
        return list
      }, [])
      return list.slice(index).concat(list.slice(0, index))
    },
    init (arr) {
      if (arr.length !== 0) {
        this.images = arr
        this.hasOldImg = true
      }
    },
    delImg (img, index) {
      if (img.isNew) {
        this.images.splice(index, 1)
      }
    },
    getList () {
      if (this.images.length === 0) {
        return []
      } else {
        return [{
          name: 'aux',
          remark: 'aux',
          userName: 'aux',
          images: this.images
        }]
      }
    },
    dropEnd (val) {
      this.images.push(...val.images)
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";
.function {
  display: flex;
  // justify-content: flex-end;
  line-height: 27px;
  .btn_white {
    width: 97px;
    height: 27px;
    background: #ffffff;
    border: 1px solid #6d6d6d;
    border-radius: 27px;
    line-height: 27px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
  }
}

.img_box {
  background-color: #f2f2f2;
  padding: 43px 64px;
  display: flex;
  flex-wrap: wrap;
  .single_img_box {
    width: 106px;
    height: 106px;
    display: flex;
    flex-direction: column;
    border-radius: 7px;
    overflow: hidden;
    border: 1px solid #6d6d6d;
    margin-bottom: 10px;
    margin-right: 13px;
    &:nth-child(9n) {
      margin-right: 0;
    }
    .img {
      flex: 1;
      overflow: hidden;
      @{deep} .el-image {
        width: 100%;
        height: 106px;
        img {
          // display: block;
          line-height: 0px;
        }
      }
    }
    .del {
      border-top: 1px solid #6d6d6d;
      font-size: 11px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      color: #2e7cd4;
      background-color: #f2f2f2;
      cursor: pointer;
    }
  }
}
</style>
